import { DecimalSeparator, NumberFormat, ThousandSeparator } from '../models/datasheet';

export function getLocaleNumberFormat(locale?: string): NumberFormat {
  const numberWithDecimalSeparator = 123456.789;
  const numberParts = Intl.NumberFormat(locale).formatToParts(numberWithDecimalSeparator);
  const decimalSeparator = numberParts.find(part => part.type === 'decimal')?.value as DecimalSeparator;
  const thousandSeparator = numberParts.find(part => part.type === 'group')?.value as ThousandSeparator;

  return { decimalSeparator, thousandSeparator };
}

export function areNumberFormatsEqual(numberFormat1: NumberFormat, numberFormat2: NumberFormat): boolean {
  return (
    numberFormat1.decimalSeparator === numberFormat2.decimalSeparator &&
    numberFormat1.thousandSeparator === numberFormat2.thousandSeparator
  );
}
